export function toggleBodyClass(className: string): void {
  const body = document.body
  if (body) {
    if (body.classList.contains(className)) {
      body.classList.remove(className)
    } else {
      body.classList.add(className)
    }
  } else {
    console.error('Body element not found.')
  }
}
